// extracted by mini-css-extract-plugin
module.exports = {"sound":"sound-slider_sound__t7h0R","soundButton":"sound-slider_soundButton___6_p2","soundSlider":"sound-slider_soundSlider__SeiW_"};